module.exports = __webpack_public_path__ + "static/media/instagram.4823f4e3.png";